<template>
  <v-dialog v-model="dialogRewardMission" persistent max-width="400">
    <v-card style="border-radius: 16px; position: relative">
      <v-card-title
        class="text-center mb-0 pt-3 pa-2 py-3 mx-auto d-block font-weight-bold"
        style="width: 100%; box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1)"
      >
        {{
          missionDetail.get_all_reward == true
            ? $t("rewardToReceive")
            : $t("chooseRewardToReceive")
        }}
      </v-card-title>
      <section
        class="d-flex flex-column px-3 mt-2 pa-3"
        style="max-height: 60vh; overflow-y: auto; margin-bottom: 0"
      >
        <!-- Choose item : New -->
        <div style="margin-top: -12px">
          <div style="height: 15px" class="mt-3 mb-3" v-if="checkRewardSelect">
            <p class="text-start text-subtitle" style="color: red">
              *{{
                $t("instructionSelectRewardMission", {
                  amount: this.totalGetReward,
                })
              }}
            </p>
          </div>

          <div
            v-for="(item, index) in missionDetail.mission_rewards"
            :key="index"
            class="pa-1"
          >
            <section
              class="d-flex flex-column"
              style="width: 100%"
              @click="toggleRewardSelection(item)"
              :style="{
                pointerEvents: missionDetail.get_all_reward ? 'none' : 'auto',
              }"
            >
              <div
                class="d-flex align-center mb-2"
                style="
                  width: 100%;
                  border-radius: 5px;
                  height: 100px;
                  transition: background-color 0.2s ease-in-out;
                "
                :style="{
                  backgroundColor: isRewardSelected(item)
                    ? 'rgba(50, 50, 93, 0.10)'
                    : '',
                }"
              >
                <v-checkbox
                  :input-value="isRewardSelected(item)"
                  :color="site.color"
                  class="mt-0 ml-3 pt-0"
                  hide-details
                  @click.stop="toggleRewardSelection(item)"
                ></v-checkbox>
                <div
                  style="
                    width: 70px;
                    min-width: 70px;
                    height: 70px;
                    overflow: hidden;
                    border-radius: 5px;
                  "
                >
                  <img
                    :src="item.image_path"
                    style="width: 100%; height: 100%; object-fit: cover"
                    @error="onImageError($event, item, 'image_path')"
                  />
                </div>
                <div
                  style="height: 70px; width: 100%; position: relative"
                  class="pl-3 pr-3"
                >
                  <div
                    class="description-label-2"
                    style="font-size: 15px; font-weight: bold"
                  >
                    {{ item.name }}
                  </div>
                  <p v-if="item.type != 'lucky draw'" style="font-size: 12px">
                    {{ $t("availableStock") }}
                    {{ item.balance_mission_reward | commaPoint }}
                  </p>
                  <p
                    style="
                      position: absolute;
                      right: 8px;
                      bottom: 0px;
                      font-size: 10px;
                      margin-bottom: 0px;
                      font-weight: bold;
                    "
                  >
                    {{ getRedeem(item) }}
                  </p>
                </div>
              </div>
              <v-divider style="border-color: rgb(0 0 0 / 20%)"> </v-divider>
            </section>
          </div>
        </div>

        <!-- Address info  -->
        <section
          class="px-2"
          v-if="shouldShowSelectAddress"
          style="height: 300px"
        >
          <h4 class="mt-3">{{ $t("selectRedeemRewardLocation") }}</h4>

          <!-- Choose address -->
          <v-radio-group v-model="detail.chooseAddress" column>
            <v-radio
              v-if="visibleShipmentIsSelf()"
              :label="
                site.label_shipment == 'รับที่จุดรับของ'
                  ? $t('deliveryPickup')
                  : site.label_shipment
              "
              value="self"
            ></v-radio>
            <v-radio
              v-if="visibleShipmentIsTransport()"
              :label="$t('selectAddressSendReward')"
              value="transport"
            ></v-radio>
          </v-radio-group>

          <div
            v-if="detail.chooseAddress === 'transport' && !userAddress"
            class="d-flex align-center pa-3 mb-3 font-weight-bold text-caption pl-5"
            :style="{ color: site.color }"
            style="
              border-radius: 8px;
              background-color: rgba(217, 217, 217, 0.3);
              margin-top: -10px;
            "
            @click="openAddressDialog"
          >
            <div style="width: 16px; height: 16px" class="mr-3">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <g data-name="51.Add">
                  <path
                    d="M12 24a12 12 0 1 1 12-12 12.013 12.013 0 0 1-12 12zm0-22a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2z"
                  />
                  <path d="M11 6h2v12h-2z" />
                  <path d="M6 11h12v2H6z" />
                </g>
              </svg>
            </div>
            {{ $t("addressAdd") }}
          </div>
          <!-- Have userAddress -->
          <div
            v-if="detail.chooseAddress === 'transport' && userAddress !== null"
            class="pa-3 mb-3"
            style="
              border-radius: 8px;
              background-color: rgba(217, 217, 217, 0.3);
              margin-top: -10px;
              position: relative;
            "
          >
            <button
              @click="openAddressDialog"
              class="font-weight-bold text-caption"
              style="position: absolute; top: 10px; right: 20px"
              :style="{ color: site.color }"
            >
              {{ $t("edit") }}
            </button>
            <p class="font-weight-bold text-caption">
              {{ userAddress.name_address }}
            </p>
            <p style="font-size: 11px; margin-top: -11px">
              {{ userAddress.name }} {{ userAddress.surname }}
              |
              <span>{{ userAddress.mobile }}</span>
            </p>
            <p style="font-size: 12px; margin-top: -11px">
              {{ userAddress.address }}
            </p>
          </div>

          <!-- Id card -->
          <div v-if="shouldShowIdCardSection">
            <v-divider style="border-color: rgb(0 0 0 / 20%)"></v-divider>
            <h4 class="mt-3">{{ $t("textUploadIDPassport") }}</h4>
            <v-file-input
              v-model="detail.file"
              class="pr-2 mt-3"
              :placeholder="$t('textSelectFile')"
              small-chips
              show-size
              dense
              @change="changeImage($event)"
              prepend-icon=""
              prepend-inner-icon="mdi-image"
              accept="image/*"
              clearable
            ></v-file-input>

            <!-- for show example with watermark -->
            <div
              style="
                width: 100%;
                border-radius: 8px;
                aspect-ratio: 1.75 / 1;
                background-color: #eeeeee;
                overflow: hidden;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #0000001a;
              "
            >
              <div
                v-if="!detail.id_card_image_watermark"
                style="
                  position: absolute;
                  width: 200%;
                  height: 200%;
                  top: -50%;
                  left: -50%;
                  transform: rotate(-30deg);
                  display: flex;
                  flex-wrap: wrap;
                  align-content: flex-start;
                  justify-content: center;
                  font-size: 28px;
                  font-weight: bold;
                  color: #00000066;
                  line-height: 1.5;
                "
              >
                <span
                  v-for="(item, index) in Array(160)"
                  :key="index"
                  style="margin: 0 24px 24px 0"
                  >{{ selected_watermark_text || "" }}&nbsp;&nbsp;&nbsp;</span
                >
              </div>
              <img
                style="width: 100%; object-fit: cover"
                :src="
                  detail.id_card_image_watermark
                    ? detail.id_card_image_watermark
                    : detail.id_card_image
                    ? detail.id_card_image
                    : defaultIdCardImage()
                "
              />
            </div>

            <!-- for download with watermark -->
            <div style="width: 1px; height: 1px; overflow: hidden">
              <div
                id="id_card_image"
                style="
                  width: 480px;
                  border-radius: 8px;
                  aspect-ratio: 1.75 / 1;
                  background-color: #eeeeee;
                  overflow: hidden;
                  position: relative;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border: 1px solid #0000001a;
                "
              >
                <div
                  style="
                    position: absolute;
                    width: 200%;
                    height: 200%;
                    top: -50%;
                    left: -50%;
                    transform: rotate(-30deg);
                    display: flex;
                    flex-wrap: wrap;
                    align-content: flex-start;
                    justify-content: center;
                    font-size: 28px;
                    font-weight: bold;
                    color: #00000066;
                    line-height: 1.5;
                  "
                >
                  <span
                    v-for="(item, index) in Array(160)"
                    :key="index"
                    style="margin: 0 24px 24px 0"
                    >{{ selected_watermark_text || "" }}&nbsp;&nbsp;&nbsp;</span
                  >
                </div>
                <img
                  style="width: 100%; object-fit: cover"
                  :src="
                    detail.id_card_image
                      ? detail.id_card_image
                      : defaultIdCardImage()
                  "
                />
              </div>
            </div>
          </div>
          <p
            v-if="shouldHaveIdCardUpload"
            class="pa-2 text-subtitle-2"
            style="color: red"
          >
            *{{ $t("instructionUploadIDPassport") }}
          </p>
          <v-divider
            style="border-color: rgb(0 0 0 / 20%); margin-top: 20px"
          ></v-divider>
          <h4 class="mt-3">{{ $t("note") }}</h4>
          <v-textarea
            v-model="detail.employee_note"
            :color="site.color"
            :placeholder="this.$t('enterNote')"
            :rows="3"
            class="rounded-lg mt-3"
            dense
            outlined
            no-resize
            background-color="white"
          />
          <div style="height: 50px"></div>
        </section>
      </section>

      <v-card-actions
        class="pb-5 d-flex flex-column"
        style="width: 100%; box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.1)"
      >
        <div class="d-flex my-2" style="height: 15px" v-if="isLoading">
          <v-progress-circular indeterminate :color="site.color" size="16" />
          <p class="ml-3 font-italic" style="color: gray">
            {{ $t("waitingLoad") }}...
          </p>
        </div>

        <v-spacer></v-spacer>
        <v-btn
          :color="site.color"
          class="mt-2 rounded-lg white--text font-weight-bold"
          depressed
          @click="confirmMissionReward()"
          :disabled="isDisabled"
          style="width: 75%; color: white; height: 40px"
        >
          {{ $t("confirm") }}
        </v-btn>

        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  emits: ["openDialogAddress", "confirmMissionReward"],
  props: {
    dialogRewardMission: {
      type: Boolean,
      default: false,
    },
    missionDetail: {
      type: Object,
      default: () => {
        return {
          id: null,
          name: null,
          mission_status: null,
          schema_survey: null,
          image_url: null,
          image_path: null,
          image_upload: null,
          description: null,
          note: null,
          mission_rewards: [],
        };
      },
    },
    userAddress: {
      type: Object,
      default: () => {
        return null;
      },
    },
    detail: {
      type: Object,
      default: () => {
        return {
          chooseAddress: "self",
          note: "",
          employee_note: "",
          is_use_id_card: false,
          id_card_image: null,
          id_card_image_watermark: null,
          watermark_text: null,
          file: null,
          image_error: null,
        };
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    rewardSelect: [],
    selected_watermark_text: null,
    checkRewardSelect: true,
    totalGetReward: 0,
    dislogAddressVisible: false,
  }),
  methods: {
    onImageError(event, item, key) {
      if (item && item[key]) {
        item[key] = "";
      } else {
        event.target.style.display = "none";
      }
    },
    visibleShipmentIsSelf() {
      let visible = false;
      if (this.site.is_shipment != "Y") {
        visible = true;
      } else {
        const reward_item = this.rewardSelect.filter(
          (x) =>
            x.type == "item" &&
            !(!x.delivery_type || x.delivery_type.length == 0)
        );
        const reward_item_delivery_type_null = this.rewardSelect.filter(
          (x) =>
            x.type == "item" &&
            (!x.delivery_type || x.delivery_type.length == 0)
        );
        const reward_pickup = reward_item.filter((x) =>
          x.delivery_type.includes("pickup")
        );
        if (
          reward_pickup.length > 0 ||
          reward_item_delivery_type_null.length > 0
        ) {
          visible = true;
        }
      }
      return visible;
    },
    visibleShipmentIsTransport() {
      let visible = false;
      if (this.site.is_shipment == "Y") {
        const reward_item = this.rewardSelect.filter(
          (x) =>
            x.type == "item" &&
            !(!x.delivery_type || x.delivery_type.length == 0)
        );
        const reward_shipping = reward_item.filter((x) =>
          x.delivery_type.includes("shipping")
        );
        if (reward_shipping.length == reward_item.length) {
          visible = true;
        }
        // if (reward_shipping.length > 0) {
        //   visible = true;
        // }
      }
      return visible;
    },
    getSelectReward() {
      if (this.missionDetail.get_all_reward == true) {
        this.rewardSelect = [...this.missionDetail.mission_rewards];
        const model = this.rewardSelect.find((x) => x.watermark_text);
        if (model?.watermark_text) {
          this.selected_watermark_text = model.watermark_text;
        }
      } else if (
        this.missionDetail.get_all_reward == false &&
        this.missionDetail.mission_rewards.length == 1
      ) {
        this.missionDetail.mission_rewards.forEach((element) => {
          this.toggleRewardSelection(element);
        });
      }
      this.totalGetReward =
        this.missionDetail.get_reward_amount >
        this.missionDetail.mission_rewards.length
          ? this.missionDetail.mission_rewards.length
          : this.missionDetail.get_reward_amount;
    },
    getRedeem(param) {
      if (
        this.missionDetail.is_approve ||
        this.missionDetail.type == "upload"
      ) {
        return "";
      }
      const formattedPoint = this.$options.filters.commaPoint(
        param.redeemp || 1
      );
      return this.$t("textRewardCount", {
        count: formattedPoint,
      });
    },
    toggleRewardSelection(item) {
      const index = this.rewardSelect.findIndex(
        (selectedItem) => selectedItem.id === item.id
      );

      if (index > -1) {
        this.rewardSelect.splice(index, 1);
      } else {
        this.rewardSelect.push(item);
        if (item.watermark_text) {
          this.selected_watermark_text = item.watermark_text;
        }
      }
    },
    isRewardSelected(item) {
      return this.rewardSelect.some(
        (selectedItem) => selectedItem.id === item.id
      );
    },
    openAddressDialog() {
      this.dislogAddressVisible = true;
      this.$emit("openDialogAddress");
    },
    changeImage(e) {
      this.detail.image_error = false;
      this.detail.file = e;
      this.detail.id_card_image = e ? URL.createObjectURL(e) : null;
      this.detail.id_card_image_watermark = null;
    },
    defaultIdCardImage() {
      return require("@/assets/images/example-thai-id.jpg");
    },
    async confirmMissionReward() {
      const data = {
        detail: this.detail,
        rewardSelect: this.rewardSelect,
      };
      // ========== ========== check visible pickup ========== ==========
      const reward_item = this.rewardSelect.filter((x) => x.type == "item");
      if (reward_item.length > 0) {
        const check_visible_pickup = this.visibleShipmentIsSelf();
        if (!check_visible_pickup && this.detail.chooseAddress == "self") {
          this.$swal({
            icon: "error",
            title: this.$t("instructionAddAddressSendReward"),
            showConfirmButton: false,
            timer: 1500,
          });
          return;
        }
      }
      this.$emit("confirmMissionReward", data);
    },
  },
  watch: {
    rewardSelect() {
      const newValue = this.rewardSelect;
      if (this.missionDetail.get_all_reward == true) {
        this.checkRewardSelect = false;
      } else if (newValue.length < this.totalGetReward) {
        this.checkRewardSelect = true;
      } else if (newValue.length > this.totalGetReward) {
        this.checkRewardSelect = true;
      } else {
        this.checkRewardSelect = false;
      }
    },
    dialogRewardMission() {
      if (this.dialogRewardMission) {
        this.getSelectReward();
      }
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    shouldShowSelectAddress() {
      return this.rewardSelect.some(
        (item) => item.type !== "lucky draw" && item.type !== "voucher"
      );
    },
    shouldShowIdCardSection() {
      return this.rewardSelect.some((item) => item.is_use_id_card === true);
    },
    shouldHaveIdCardUpload() {
      const isUseIdCard = this.rewardSelect.some(
        (item) => item.is_use_id_card === true
      );
      return isUseIdCard && !this.detail.id_card_image;
    },
    isDisabled() {
      const isUseIdCard = this.rewardSelect.some(
        (item) => item.is_use_id_card === true
      );
      return (
        this.checkRewardSelect || // reward not selected
        this.isLoading || // still loading
        (isUseIdCard && !this.detail.id_card_image) ||
        (this.detail.chooseAddress === "transport" && !this.userAddress)
      );
    },
  },
  filters: {
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>

<style>
</style>